// src/axiosForm.js
import axios from "axios";
import Cookies from "js-cookie";
import {API_BASE_URL} from "./config";

const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

instance.interceptors.request.use((config) => {
  const token = Cookies.get("employeeToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default instance;
